

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import TemplateModal from '@/components/TemplateModal/TemplateModal.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import eventBus from '@/utils/eventBus';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import Row from '@/components/atoms/Grid/Row.vue';

@Component({
  components: {
    TemplateModal,
    TextField,
    Row
  }
})
export default class TransactionActionConfirmationModal extends Vue {
  @Prop({ required: true }) transaction!: any;
  @Prop({ required: true }) action!: 'clear' | 'refund';
  service = new AdminService();
  loading = false;

  modalStyle = this.action === 'refund' ? { height: '400px' } : {};
  maxValue =
    parseFloat(this.transaction.amount.replace('$', '')) -
    parseFloat(this.transaction.rawData.refundAmount) / 100;
  amountValue = this.maxValue.toString();

  get text() {
    return `Are you sure you want to ${this.action.toUpperCase()} this transaction?`;
  }

  setAmount(value: number) {
    try {
      this.amountValue = value.toString();
    } catch (err) {
      this.amountValue = '0';
    }
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  async onConfirm() {
    try {
      this.loading = true;
      switch (this.action) {
        case 'clear':
          await this.service.clearTransaction(this.transaction.id);
          break;
        case 'refund':
          if (parseFloat(this.amountValue) <= this.maxValue) {
            await this.service.refundTransaction(
              this.transaction.id,
              parseFloat(this.amountValue)
            );
          }

          break;
      }
      this.onClose();
    } catch (err) {
      this.$notification(treatError(err));
    } finally {
      this.loading = false;
    }
  }
}
